module.exports = __webpack_public_path__ + "img/cheek_swab_envelope.dda71d29.png";